import React from 'react';
import {Dropdown as AntDropdown} from 'antd';
import './Dropdown.less';
export default class Dropdown extends AntDropdown {

    render(){
        return <AntDropdown {...this.props} className={`hms-dropdown ${this.props.className || ''}`}>{this.props.children}</AntDropdown>
    }
}